<div class="py-10">
    <p class="text-2xl">Risultati di ricerca</p>
    @for (result of searchResults(); track $index) {
    <div>
        <i class="pi pi-file-pdf" style="font-size: 1rem"></i>
        <button type="button" class="btn btn-link p-0" (click)="openFileLink(result.link)">
            {{ result.title }}
        </button>
        <p class="text-sm text-gray-600 w-full" [innerHTML]="result.snippets.join() | safeHtml"></p>
    </div>
    }
</div>